import { Spreadsheet } from '@/components/spreadsheet/spreadsheet';
import * as _ from 'lodash';
import * as moment from 'moment';

export class DapSpreadsheetStores extends Spreadsheet {
  name: string = 'dap_project_stores';

  mount(dataSource: any) {
    const sections: Array<any> = [
      { key: 'main', text: 'DEALER', index: 0 },
      { key: 'updated', text: 'UPDATED', index: 7 },
      { key: 'conversionDate', text: 'CONVERSION', index: 8 },
      { key: 'sales', text: 'SALES', index: 9 },
      { key: 'transform', text: 'TRANSFORMAÇÃO', index: 11 },
      { key: 'matrix', text: 'MATRIZ', index: 14 },
      { key: 'address', text: 'LOCALIZAÇÂO', index: 16 }
    ];

    const sectionColumns: any = {
      main: [
        { key: 'dealerNumber', text: 'DN', textAlign: 'center' },
        { key: 'name', text: 'NOME' },
        { key: 'typeName', text: 'TIPO' },
        { key: 'city', text: 'CIDADE' },
        { key: 'state', text: 'UF' },
        { key: 'groupName', text: 'GRUPO' },
        { key: 'dateOpening', text: 'DATA ABERTURA', textAlign: 'center' }
      ],
      updated: [
        { key: 'modificationHistory', text: 'DATA', textAlign: 'center' }
      ],
      conversionDate: [
        { key: 'dateConversion', text: 'DATA', textAlign: 'center' }
      ],
      sales: [
        { key: 'sales', text: `${moment(dataSource[0].initialHistoryPeriod).format('MMM/YY')} A ${moment(dataSource[0].finalHistoryPeriod).format('MMM/YY')}`.toUpperCase(), textAlign: 'center' },
        { key: 'monthsWithSales', text: 'QTD MESES', textAlign: 'center' }
      ],
      transform: [
        { key: 'percentDivision', text: 'DIVISÃO', textAlign: 'center', format: '#0%' },
        { key: 'percentGrowth', text: 'CRESCIMENTO', textAlign: 'center', format: '#0%' },
        { key: 'percentRate', text: 'RATEIO', textAlign: 'center', format: '#0%' }
      ],
      matrix: [
        { key: 'idStoreMatrix', text: 'DN MATRIZ', textAlign: 'center' },
        { key: 'matrixName', text: 'NOME MATRIZ' }
      ],
      address: [
        { key: 'area', text: 'MARKED AREA' },
        { key: 'region', text: 'REGION' },
        { key: 'aov', text: 'AOV' },
        { key: 'regionale', text: 'REGIONAL' },
        { key: 'address', text: 'LOGRADOURO' },
        { key: 'city', text: 'CIDADE' },
        { key: 'neighborhood', text: 'BAIRRO' },
        { key: 'state', text: 'UF' },
        { key: 'cep', text: 'CEP' },
        { key: 'latitude', text: 'LATITUDE' },
        { key: 'longitude', text: 'LONGITUDE' }
      ]
    };

    const baseStyle: any = {
      textAlign: 'left',
      fontSize: 11,
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseHeaderStyle: any = {
      color: '#FFFFFF',
      fontSize: 11,
      bold: true,
      textAlign: 'center',
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseColorStyle: any = {
      address: '#e57373',
      header: '#616161',
      main: '#455a64',
      matrix: '#64b5f6',
      sales: '#ffb74d',
      transform: '#ffb74d',
      updated: '#81c784',
      conversionDate: '#c7be81'
    };

    const baseBorderColorStyle: any = {
      address: '#ffcdd2',
      info: '#cfd8dc',
      main: '#eee',
      matrix: '#bbdefb',
      sales: '#ffe0b2',
      transform: '#ffe0b2',
      updated: '#c8e6c9',
      conversionDate: '#c7be81'
    };

    const baseBackgroundColorStyle: any = {
      address: '#fff5f6',
      info: '#f9fafb',
      main: '#fafafa',
      matrix: '#edf7ff',
      sales: '#fffbf5',
      transform: '#fffbf5',
      updated: '#f4f9f5',
      conversionDate: '#fffdef'
    };

    const headerStyle = _.reduce(
      sections,
      (acc: any, section: any) => {
        acc[section.key] = _.assign({}, baseHeaderStyle, { background: baseColorStyle[section.key] });
        return acc;
      },
      {}
    );

    const getCellStyle = (data: any, key: any) => {
      return _.assign({}, baseStyle, {
        background: baseBackgroundColorStyle[key],
        borderLeft: { color: baseBorderColorStyle[key], size: 1 },
        borderRight: { color: baseBorderColorStyle[key], size: 1 },
        borderTop: { color: baseBorderColorStyle[key], size: 1 },
        borderBottom: { color: baseBorderColorStyle[key], size: 1 }
      });
    };

    this.workbookOptions = {
      sheets: _.map(
        _(dataSource)
          .groupBy(d => d.tabName)
          .value(),
        (data: any) =>
          ({
            name: 'DEALERS',
            frozenColumns: 2,
            frozenRows: 2,
            filter: {
              ref: `A2:W${data.length + 2}`,
              columns: []
            },
            rows: [
              {
                cells: [
                  ..._.map(sections, (section: any) =>
                    _.assign({}, headerStyle[section.key], {
                      value: section.text,
                      index: section.index,
                      borderLeft: { color: baseBorderColorStyle[section.key], size: 1 },
                      borderRight: { color: baseBorderColorStyle[section.key], size: 1 }
                    })
                  )
                ]
              },
              {
                cells: [
                  ..._(sectionColumns)
                    .map((columns: any, key: any) =>
                      _.map(columns, (cell: any) =>
                        _.assign({}, headerStyle[key], {
                          value: cell.text,
                          wrap: true,
                          borderLeft: { color: baseBorderColorStyle[key], size: 1 },
                          borderRight: { color: baseBorderColorStyle[key], size: 1 },
                          borderTop: { color: baseBorderColorStyle[key], size: 1 },
                          borderBottom: { color: baseBorderColorStyle[key], size: 1 }
                        })
                      )
                    )
                    .flatten()
                    .value()
                ]
              },
              ..._.map(data, d => {
                return {
                  cells: [
                    ..._(sectionColumns)
                      .map((columns: any, key: any) =>
                        _.map(columns, (cell: any) => {
                          if (cell.key === 'dateConversion') {
                            return _.assign({}, getCellStyle(d[cell.key], key), {
                              value: d[cell.key] ? moment(d[cell.key]).format('L') : '-',
                              textAlign: cell.textAlign
                            });
                          }else if (cell.key === 'dateOpening') {
                            return _.assign({}, getCellStyle(d[cell.key], key), {
                              value: moment(d[cell.key]).format('L'),
                              textAlign: cell.textAlign
                            });
                          } else if (cell.key === 'modificationHistory') {
                            const updatedAt = d[cell.key].length
                              ? new Date(d[cell.key][d[cell.key].length - 1].updatedAt)
                              : '-';
                            return _.assign({}, getCellStyle(d[cell.key], key), {
                              value: updatedAt,
                              textAlign: cell.textAlign
                            });
                          } else {
                            return _.assign({}, getCellStyle(d[cell.key], key), {
                              value: d[cell.key],
                              textAlign: cell.textAlign,
                              format: cell.format
                            });
                          }
                        })
                      )
                      .flatten()
                      .value()
                  ]
                };
              })
            ],
            columns: [
              {
                index: 0,
                width: 80
              },
              {
                index: 1,
                width: 200
              },
              {
                index: 2,
                width: 50
              },
              {
                index: 3,
                width: 150
              },
              {
                index: 4,
                width: 50
              },
              {
                index: 5,
                width: 120
              },
              {
                index: 6,
                width: 100
              },
              {
                index: 7,
                width: 100
              },
              {
                index: 8,
                width: 100
              },
              {
                index: 9,
                width: 100
              },
              {
                index: 10,
                width: 90
              },
              {
                index: 11,
                width: 90
              },
              {
                index: 12,
                width: 90
              },
              {
                index: 13,
                width: 90
              },
              {
                index: 14,
                width: 100
              },
              {
                index: 15,
                width: 250
              },
              {
                index: 16,
                width: 250
              },
              {
                index: 17,
                width: 250
              },
              {
                index: 18,
                width: 250
              },
              {
                index: 19,
                width: 250
              },
              {
                index: 20,
                width: 150
              },
              {
                index: 21,
                width: 250
              },
              {
                index: 22,
                width: 200
              },
              {
                index: 23,
                width: 150
              },
              {
                index: 24,
                width: 50
              },
              {
                index: 25,
                width: 90
              },
              {
                index: 26,
                width: 90
              }
            ],
            showGridLines: true,
            mergedCells: ['A1:G1', 'J1:K1', 'L1:N1', 'O1:P1', 'Q1:AA1']
            // mergedCells: ['A1:G1', 'I1:J1', 'K1:M1', 'N1:O1', 'P1:Z1']
          } as any)
      )
    };

    return this;
  }
}
